export default function throttle(fn, wait) {
	let last = 0;
	return function (...args) {
		const now = Date.now();
		if (now - last < wait) return;
		last = now;
		return fn(...args);
	};
}